import React, { useState } from "react";
import { MdAdd, MdDeleteOutline } from "react-icons/md";
import { useTranslation } from "react-i18next";

const BusinessHoursComp = ({ handleClose, setBusinessHours, setTimeZone, isOpen }) => {

  const { t } = useTranslation();
  const timezones =
    Intl.supportedValuesOf && Intl.supportedValuesOf("timeZone")
      ? Intl.supportedValuesOf("timeZone")
      : [
        "UTC",
        "America/New_York",
        "America/Los_Angeles",
        "Asia/Kolkata",
        "Europe/London",
        "Europe/Berlin",
        "Australia/Sydney",
        // Add more timezones if needed
      ];

  const [selectedTimezone, setSelectedTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

  const UploadApiOpeningHour = async () => {
    setTimeZone(selectedTimezone);
    setBusinessHours(schedule);
    handleClose();
  };

  const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const [schedule, setSchedule] = useState(
    days.map((day) => ({
      day,
      isOff: false,
      timeSlots: [{ opening: "09:00", om: "AM", closing: "17:00", cm: "PM" }],
    }))
  );

  const handleToggle = (day) => {
    setSchedule((prev) =>
      prev.map((d) =>
        d.day === day ? { ...d, isOff: !d.isOff } : d
      )
    );
  };

  const handleTimeChange = (day, index, field, value) => {
    setSchedule((prev) => prev.map((d) => d.day === day ?
      {
        ...d,
        timeSlots: d.timeSlots.map((slot, i) => i === index ? { ...slot, [field]: value } : slot),
      }
      : d
    )
    );
  };
  const addTimeSlot = (day) => {
    setSchedule((prev) =>
      prev.map((d) =>
        d.day === day ? d.timeSlots.length < 2 ? {
          ...d,
          timeSlots: [
            ...d.timeSlots,
            { opening: "09:00", closing: "09:00" },
          ],
        } : d // Don't add more if already 2
          : d
      )
    );
  };

  const removeTimeSlot = (day, index) => {
    setSchedule((prev) =>
      prev.map((d) => d.day === day ?
        {
          ...d, timeSlots: d.timeSlots.length > 1 ?
            d.timeSlots.filter((_, i) => i !== index)
            : [{ opening: "09:00", closing: "09:00" }]
        }
        : d
      )
    );
  };

  return (
    <div className="popup-box">
      <div
        className="box"
        style={{
          marginTop: isOpen === true ? "calc(100vh - 90vh - 20px)" : "100px",
          padding: isOpen === true ? "30px 00px" : "20px",
          maxHeight: 700, overflow: 'auto'
        }}
      >
        <>
          <h4 className="my-3 text-center text-bold text-dark">
            Business Hours
          </h4>
          <div className="w-100">
            <div className="container d-flex flex-column align-items-center">

              <div className="text-start" style={{ width: '70%' }}>
                <div>
                  <p className="fs-5 text-dark mt-2" style={{ marginBottom: "2px" }}>
                    {t('timeZone')} : {selectedTimezone}
                  </p>
                  <select
                    className="form-select"
                    value={selectedTimezone}
                    onChange={(e) => setSelectedTimezone(e.target.value)}
                    style={{
                      width: "100%",
                      backgroundColor: "#ECECEC",
                    }}
                  >
                    {timezones.map((tz) => (
                      <option key={tz} value={tz}>
                        {tz}
                      </option>
                    ))}
                  </select>
                </div>

                {schedule.map(({ day, isOff, timeSlots }) => (
                  <div key={day} style={{ borderBottom: "1px solid #ccc", padding: "10px 0" }}>
                    <div className="d-flex justify-content-between pt-1">
                      <div className="d-flex flex-column align-self-start">
                        <b>{day}</b>
                        <div className="d-flex">
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={isOff}
                              onChange={() => handleToggle(day)}
                            />
                            <span className="slider"></span>
                          </label>
                          &nbsp;{t('closed')}
                        </div>
                      </div>

                      {!isOff && (
                        <div className="d-flex flex-column align-items-end pt-1">
                          {timeSlots.map((slot, index) => (
                            <TimeInputRow
                              key={index}
                              day={day}
                              index={index}
                              slot={slot}
                              onChange={handleTimeChange}
                              onRemove={removeTimeSlot}
                              addTimeSlot={addTimeSlot}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ width: "80%", margin: "25px 0%", display: "flex", justifyContent: "center" }}>
                <button
                  className="bg-primary text-white rounded-3 border-0 mx-4"
                  style={{ fontSize: "14px", width: "23%", padding: "10px" }}
                  onClick={() => UploadApiOpeningHour()}
                >
                  Update
                </button>
                <button
                  className="bg-primary text-white rounded-3 border-0 mx-4"
                  style={{ fontSize: "14px", width: "23%", padding: "10px" }}
                  onClick={() => { handleClose() }}
                >
                  {t('close')}
                </button>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

const TimeInputRow = ({ day, index, slot, onChange, onRemove, addTimeSlot }) => (

  <div className="d-flex align-items-center mb-2" >
    <input
      type="time"
      value={slot.opening}
      onChange={(e) => onChange(day, index, "opening", e.target.value)}
      style={{ width: "45%", backgroundColor: "#ECECEC", borderColor: "#ECECEC" }}
      className="form-control"
      aria-label="Opening Time"
    />
    <span>&nbsp;to&nbsp;</span>
    <input
      type="time"
      value={slot.closing}
      onChange={(e) => onChange(day, index, "closing", e.target.value)}
      style={{ width: "45%", backgroundColor: "#ECECEC", borderColor: "#ECECEC" }}
      className="form-control"
      aria-label="Closing Time"
    />
    {index > 0 ?
      <button onClick={() => onRemove(day, index)} className="btn btn-sm bg-transparent">
        <MdDeleteOutline />
      </button>
      :
      <button
        onClick={() => addTimeSlot(day)}
        className="btn btn-sm bg-transparent"
      >
        <MdAdd />
      </button>
    }
  </div>
);

export default BusinessHoursComp;